import T from 'i18n-react';
import OperationTypeEnum from '../enums/OperationTypeEnum';
import CardType from '../enums/CardType';
import OPERATION_CATEGORY from '../enums/OperationCategoryEnum';
import JobType from "../enums/JobType";
import LOCATION from '../enums/Location';
import STREAM_TYPE from '../enums/StreamType';
import OperationService from '../services/OperationService';

const convertListToCsv = (dataList, headerList) => {
    let result = headerList.join(';') + '\r\n'
    dataList.forEach((subArray) => {
        result += subArray.join(';') + '\r\n'
    });
    return result
};

export const downloadCsv = (list, headerList, filename) => {
    const csv = convertListToCsv(list, headerList)
    const uri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv)
    if (navigator.msSaveBlob) { // IE 10 +
        const blob = new Blob([ '\ufeff', csv ],  {type: "text/csv"});
        navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        let link = document.createElement('a')
        link.setAttribute('href', uri)
        link.setAttribute('download', filename)
        document.body.appendChild(link);        
        link.click()
        document.body.removeChild(link);        
    }
};

export const operationCSVHeader = (operationList, country) => {
    if(!operationList || operationList.length < 1) {
        return
    }

    // on construit le header des fichiers FR, avec une colonne de plus. Les PROCESSING_FEES, UNPAID_FRA et FRA ont tous une activité non nulle
    if (country === LOCATION.FR) {
        return [
            T.translate("tableHeader.date"),
            T.translate("table.contractNumber"),
            T.translate('tableHeader.client'),
            T.translate('table.society'),
            T.translate("table.nameShop"),
            T.translate("table.tradeDateLong"),
            T.translate("table.activity"),
            T.translate("table.nbTransactions"),
            T.translate("table.sens"),
            T.translate("table.grossAmount") + " €",
            T.translate("table.commission") + " €",
            T.translate("table.netAmout") + " €"
        ];
    } else {
        // sinon, on traite le cas des N43 ou CODA
        return [
            T.translate("tableHeader.date"),
            T.translate("table.contractNumber"),
            T.translate('tableHeader.client'),
            T.translate('table.society'),
            T.translate("table.nameShop"),
            T.translate("table.tradeDateLong"),
            operationList[0].cardType ? T.translate("table.cardType") : T.translate("table.operationType"),
            T.translate("table.sens"),
            T.translate("table.grossAmount") + " €",
            T.translate("table.commission") + " €",
            T.translate("table.netAmout") + " €"
        ];
    }
};

export const userCSVHeader = () => {
    return [
        T.translate('manageUser.name'),
        T.translate('manageUser.profile'),
        T.translate('manageUser.client'),
        T.translate('manageUser.society'),
        T.translate('manageUser.shop'),
        T.translate('manageUser.email'),
        T.translate('manageUser.login'),
        T.translate('manageUser.phoneNumber'),
        T.translate('manageUser.canManageUsers')
    ];
};

export const exportUserData = (userList, filename) => {
    const header = userCSVHeader();
    downloadCsv(userList, header, filename)
};

export const exportOperationCsv = (operationList, filename, jobType, country) => {
    const dataList = formatOperationData(operationList, jobType)
    const header = operationCSVHeader(operationList, country)
    downloadCsv(dataList, header, filename)
};

export const formatOperationData = (operationList, jobType) => {
    let dataList = [];

    switch(jobType) {
        // on construit le CSV des lignes FRA, UNPAID_FRA et PROCESSING_FEES FR
        case JobType.FRA :
            operationList.forEach((item) => {
                dataList.push(
                    [
                        '"' + item.fundingDate + '"',
                        '"' + (item.streamType === STREAM_TYPE.PASS_CARD.code ? item.shopPass : item.contractNumber) + '"',
                        '"' + null + '"',
                        '"' + null + '"',
                        '"' + item.nameShop + '"',
                        '"' + item.tradeDate + '"',
                        '"' + OperationService.getDataActivity(item).text + '"',
                        '"' + ((item.category === OPERATION_CATEGORY.FRA && item.nbTransactions != null) || item.category === OPERATION_CATEGORY.UNPAID_FRA ? item.nbTransactions.toString() : '') + '"',
                        '"' + (item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                T.translate('table.processingFees')
                                :
                                item.sens > 0 ? T.translate('table.debit') : T.translate('table.credit')
                        ) + '"',
                        '"' + (item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                0
                                :
                                this.formatAmount(item.grossAmount)
                        ) + '"',
                        '"' + this.formatAmount(item.netAmount - item.grossAmount) + '"',
                        '"' + this.formatAmount(item.netAmount) + '"'
                    ]
                );
            })
            break;
        // on construit le CSV des lignes CODA et PROCESSING_FEES BE
        case JobType.CODA:
            operationList.forEach((item) => {
                dataList.push(
                    [
                        '"' + item.fundingDate + '"',
                        '"' + item.contractNumber + '"',
                        '"' + null + '"',
                        '"' + null + '"',
                        '"' + item.nameShop + '"',
                        '"' + item.tradeDate + '"',
                        '"' + T.translate(CardType[item.cardType].name)  + '"',
                        '"' + (item.category && item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                T.translate('table.processingFees')
                                :
                                item.sens > 0 ? T.translate('table.debit') : T.translate('table.credit')
                        ) + '"',
                        '"' + (item.category && item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                0
                                :
                                this.formatAmount(item.grossAmount)
                        ) + '"',
                        '"' + this.formatAmount(item.netAmount - item.grossAmount) + '"',
                        '"' + this.formatAmount(item.netAmount) + '"'
                    ]
                );
            })
            break;
        // on construit le CSV des lignes N43 et PROCESSING_FEES ES
        case JobType.N43 :
            operationList.forEach((item) => {
                dataList.push(
                    [
                        '"' + item.fundingDate + '"',
                        '"' + item.contractNumber + '"',
                        '"' + null + '"',
                        '"' + null + '"',
                        '"' + item.nameShop + '"',
                        '"' + item.tradeDate + '"',
                        '"' + (item.operationType && item.sens ? OperationTypeEnum[item.operationType.toString() + item.sens.toString()] : "") + '"',
                        '"' + (item.category && item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                T.translate('table.processingFees')
                                :
                                item.sens > 0 ? T.translate('table.debit') : T.translate('table.credit')
                        ) + '"',
                        '"' + (item.category && item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                0
                                :
                                this.formatAmount(item.grossAmount)
                        ) + '"',
                        '"' + this.formatAmount(item.netAmount - item.grossAmount) + '"',
                        '"' + this.formatAmount(item.netAmount) + '"'
                    ]
                );
            })
            break;
        default:
            break;
    }

    return dataList;
}

export const formatAmount = (amount) => {
    return (amount / 100).toFixed(2).replace('.', ',');
}


// WEBPACK FOOTER //
// ./src/utils/ExportCsvUtils.js